import * as React from 'react';
import { FormEvent } from 'react';
import classNames from 'classnames/bind';
import styles from './customVideoPlayerControlPanel.module.scss';

const cx = classNames.bind(styles);

interface Props {
  isPlaying: boolean;
  totalDuration: number;
  currentSeek: number;
  onClickPlay(): void;
  onClickPause(): void;
  onChangeSeek(e: FormEvent<HTMLInputElement>): void;
}

const CustomVideoPlayerControlPanel = (props: Props) => {
  const { isPlaying, totalDuration, currentSeek, onChangeSeek, onClickPlay, onClickPause } = props;

  const handleClickPlayPause = () => {
    if (isPlaying) {
      onClickPause();
    } else {
      onClickPlay();
    }
  };

  const getTimeText = (seconds: number) => {
    if (seconds === Infinity) {
      return '00:00';
    }
    const min = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const sec = Math.floor(seconds - Number(min) * 60)
      .toString()
      .padStart(2, '0');
    return min + ':' + sec;
  };

  return (
    <div className={cx('panel')}>
      <button className={cx('playPauseBtnWrap')} onClick={handleClickPlayPause}>
        <svg className={cx('playPauseBtn')}>
          {isPlaying ? (
            <>
              <rect width="6" height="16" />
              <rect x="10" width="6" height="16" />
            </>
          ) : (
            <polygon points={'4,1 16,8 4,15'} />
          )}
        </svg>
      </button>
      <input
        className={cx('range')}
        type={'range'}
        value={currentSeek}
        min={0}
        max={totalDuration}
        onInput={(e) => onChangeSeek(e)}
      />
      <div className={cx('duration')}>
        {getTimeText(currentSeek)} / {getTimeText(totalDuration)}
      </div>
    </div>
  );
};

export default CustomVideoPlayerControlPanel;
